import {useNavigate} from 'react-router-dom';
import DefaultImage from '../../../../../../../assets/image/newShop/defaultImg.png';
import {getPersianDateTimeV2} from '../../../../../../../utilities/helper/GetPersianDateTime';
import InfoRow from '../../../../../../shopping-basket/ItemCard/InfoRow';

const RejectedAdvertisementCard = ({
  storeAd,
}: {
  storeAd: IGetMyStoreAdsData;
}) => {
  const navigate = useNavigate();

  const imageSrc =
    storeAd?.main_image?.image ??
    storeAd?.main_image?.image_128 ??
    storeAd?.sub_brand_main_image?.image ??
    DefaultImage;

  return (
    <div className="relative border-[1px] border-gray-300 shadow-sm shadow-gray-100 rounded-lg p-3 gap-3 flex flex-col text-md">
      <div className="flex gap-4">
        <img
          src={imageSrc}
          alt="عکس آگهی"
          className="rounded-lg size-[4.5rem]"
        />
        <div className="flex flex-col w-full space-y-4">
          <span className="block w-full min-w-0 mt-2 overflow-hidden font-medium text-neutral-900 text-ellipsis whitespace-nowrap line-clamp-1 max-w-48">
            {storeAd?.title}
          </span>

          <InfoRow
            icon="icon-nameCalendar  text-lg"
            valueClassName="text-blue-950 font-normal text-md"
            label="تاریخ ثبت آگهی"
            value={getPersianDateTimeV2(storeAd?.created_at)}
            className="gap-2 pt-0 mt-2 w-fit"
          />

          <div
            className="flex items-center gap-2 pt-0 mt-2 font-medium text-md text-farm-shop-600"
            onClick={() => {
              navigate(`/my-ads/advertisment/${storeAd?.id}`, {
                state: {
                  type: 'advertisement',
                  advertisement_type: storeAd?.advertisement_type,
                },
              });
            }}
          >
            <i className="text-lg icon-nameEdit-Square" />
            <span className="">ویرایش آگهی</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RejectedAdvertisementCard;
